import { render, staticRenderFns } from "./CreateTreatmentTab.vue?vue&type=template&id=001edbac&scoped=true"
import script from "./CreateTreatmentTab.vue?vue&type=script&lang=js"
export * from "./CreateTreatmentTab.vue?vue&type=script&lang=js"
import style0 from "./CreateTreatmentTab.vue?vue&type=style&index=0&id=001edbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001edbac",
  null
  
)

export default component.exports